import React, { JSX } from "react";

const FormSwitch = ({
    entity,
    fieldName,
    handleInputChange,
    label,
    errors
}: {
    entity: any;
    fieldName: string;
    handleInputChange: any;
    label?: string;
    errors?: any;
}) => {
    return (
        <div className="d-flex justify-content-between align-items-center mb-3 form-switch ps-0">
            <label className="form-check-label ps-2" style={{ color: errors?.[fieldName] ? "red" : "" }} htmlFor={fieldName}>{label ? label : fieldName}</label>
            <input
                className={`form-check-input is-valid me-2 ${errors?.[fieldName] && 'is-invalid'}`}
                type="checkbox"
                role="switch"
                id={fieldName}
                checked={entity[fieldName]??false}
                onChange={(e) =>
                    handleInputChange({
                        target: {
                            id: fieldName,
                            value: e.target.checked,
                        },
                    })}
            />
            {
                errors?.[fieldName] && (
                    <div className="invalid-feedback">
                        {errors?.[fieldName]}
                    </div>
                )
            }
        </div >
    );
};

export default FormSwitch;
